import React, {useEffect, useState} from "react";
import money from "../image/money.svg";
import problemsimg from "../image/problems img.svg";
import {Navigate, useNavigate} from "react-router-dom";
import {useContext} from "react";
import { toJalaliDate } from '../utils/date';
import {UseContext} from "../context";
import Loadingcom from "./allcomponent/Loading";
import {notification} from "antd";

// react icons 
import {MdContactSupport} from "react-icons/md";
import {IoIosArrowRoundBack} from "react-icons/io";
import {PiUserListFill} from "react-icons/pi";
import {TbMessageFilled} from "react-icons/tb";
import axios from "axios";
import {url} from "../url";
import {IoMdSend} from "react-icons/io";
import Loading from "./allcomponent/Loading";
import PendingApprovalScreen from "./allcomponent/PendingApproval";

const Supportcom = () => {
    const navigate = useNavigate();
    const {getmyprof, getprofloading} = useContext(UseContext);
    const [openTicket, setOpenTicket] = useState(false)
    const [ticketSubject, setTicketSubject] = useState("")
    const [userTickets, setUserTickets] = useState(false)
    const [ticketMessage, setTicketMessage] = useState("")
    const [openMessagePage, setOpenMessagePage] = useState(false)
    const [noMessages, setNoMessages] = useState(false)
    const [specificMessagePage, setSpecificMessagePage] = useState([])
    const [internetProblems, setInternetProblems] = useState(false)

    const [loading, setLoading] = useState(false)

    // ticket data
    const [allTickets, setAllTickets] = useState([])
    const [ticketId, setTicketId] = useState("")
    const [answerDescription, setAnswerDescription] = useState("");
    const [updateMessagePanel, setUpdateMessagePanel] = useState(false)
    const [ticketStatus, setTicketStatus] = useState(null);
    const [, setUpdateTickets] = useState(false)

    const [loadingForTicket, setLoadingForTicket] = useState(false)

    console.log(userTickets)

    useEffect(() => {

        if (userTickets) {

            setLoadingForTicket(true)
            axios.get(`${url}/tickets/v1/get-my-ticket-list-driver`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            }).then(res => {
                setLoadingForTicket(false)
                setAllTickets(res.data.data.docs);
                console.log(res.data);
            }).catch(err => {
                setLoadingForTicket(false)
            })
        }
    }, [userTickets])

    const sendTicket = () => {
        setLoading(true)
        axios.post(`${url}/tickets/v1/add-ticket-driver`, {
            subject: ticketSubject,
            description: ticketMessage
        }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            }
        }).then(res => {
            notification.success({
                message: "پیام شما با موفقیت ارسال شد."
            })
            setLoading(false)
            setUpdateTickets(prev => !prev)
        }).catch(err => {
            if (err.response.status === 400) {
                notification.error({
                    message: "لطفا پیام مورد نظر خود را بنویسید !"
                });
            }
            setLoading(false)
        })
        setTicketMessage("")
    }


    const openSpecificTicket = () => {
        setNoMessages(false)
        setInternetProblems(false)
        setOpenMessagePage(true)
        axios.get(`${url}/tickets/v1/get-ticket-messages-driver/${ticketId}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        }).then(res => {
            setSpecificMessagePage(res.data.data)
            setInternetProblems(false)
            setNoMessages(false)

        }).catch(err => {
            // notification.error({
            //   message: err?.response?.data?.message
            // })
            if (err?.response?.status === 404)
                setNoMessages(true)
            if (err?.message === "Network Error")
                setInternetProblems(true)

            console.log(err);
        })
    }

    useEffect(() => {
        if (ticketId)
            openSpecificTicket()
    // This effect is intentionally triggered only by the selected ticket and message refresh flag.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateMessagePanel, ticketId])

    const sendMessageToAdmin = () => {
        axios.put(`${url}/tickets/v1/driver-answer-ticket/${ticketId}`, {
            description: answerDescription
        }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            }
        }).then(res => {
            console.log('hooray');
            setAnswerDescription("")
            setUpdateMessagePanel(prev => !prev)
        }).catch(err => {
            if (err) {
                notification.error({
                    message: "فرستادن پیام با مشکل روبرو شد !"
                })
            }
        })
    }

    return (
        <>
            {localStorage.getItem("token") !== null ? (
                <>
                    {getprofloading === false ? (
                        <>
                            {getmyprof.status === "profile_not_completed" ? (
                                <Navigate to="/UserandCarinformation"/>
                            ) : (
                                <>
                                    {getmyprof.status === "pending" ? (
                                        <div
                                            className="w-full flex flex-col h-full  overflow-auto mb-[100px] lg:mb-[88px]">
                                            <PendingApprovalScreen />
                                        </div>
                                    ) : (
                                        // ------------------- main support menu -------------------
                                        <>
                                            <div
                                                id="supportdiv"
                                                className={`h-full w-full ${openTicket ? "hidden" : "block"} ${userTickets ? "hidden" : "block"}`}
                                            >
                                                <div className="pr-4 mt-3 flex cursor-pointer items-center gap-x-2">
                                                    <MdContactSupport className="text-amber-400 text-[26px]"/>
                                                    <p className="text-[24px] font-medium">پشتیبانی</p>
                                                </div>

                                                <div
                                                    onClick={() => {
                                                        setOpenTicket(true)
                                                        setLoading(false)
                                                        setTicketSubject("پرداخت کرایه")
                                                    }}
                                                    className="h-[104px] bg-bordercircle rounded-[10px] mx-4 mt-7 cursor-pointer"
                                                >
                                                    <div className="flex justify-center ">
                                                        <img alt="" className=" mt-4" src={money}></img>
                                                    </div>
                                                    <p className="text-[14px] font-normal text-center pt-2">
                                                        پرداخت کرایه
                                                    </p>
                                                </div>

                                                <div
                                                    onClick={() => {
                                                        setTicketSubject("مشکلات برنامه")
                                                        setLoading(false)
                                                        setOpenTicket(true)
                                                    }}
                                                    className="h-[104px] bg-bordercircle rounded-[10px] mx-4 mt-5 cursor-pointer">
                                                    <div className="flex justify-center ">
                                                        <img alt="" className=" mt-4" src={problemsimg}></img>
                                                    </div>
                                                    <p className="text-[14px] font-normal text-center pt-2">
                                                        مشکلات برنامه
                                                    </p>
                                                </div>

                                                <div onClick={() => setUserTickets(true)}
                                                     className="h-[104px] bg-bordercircle rounded-[10px] mx-4 mt-5 cursor-pointer">
                                                    <div className="flex justify-center ">
                                                        <PiUserListFill className="text-[46px] mt-2"/>
                                                    </div>
                                                    <p className="text-[14px] font-normal text-center pt-2">
                                                        تیکت های ثبت شده
                                                    </p>
                                                </div>
                                            </div>


                                            {/* ------------------ open ticket menu ------------------------- */}


                                            <div className={`${openTicket ? "block" : "hidden"} w-full h-full mt-1`}>
                                                <div
                                                    className="w-full flex justify-end pl-3 mb-3 rotate-180 text-[40px]">
                                                    <IoIosArrowRoundBack onClick={() => setOpenTicket(false)}
                                                                         className="cursor-pointer"/></div>
                                                <div className="w-full pr-10">
                                                    <h2 className="list-item">موضوع تیکت : <span
                                                        className="text-slate-700">{ticketSubject}</span></h2>
                                                </div>

                                                <div className="w-full px-5 mt-4">
                                                    <div className="flex items-center gap-x-2">
                                                        <TbMessageFilled/>
                                                        <p>لطفا پیام تیکت خود را بنویسید :</p>
                                                    </div>

                                                    <textarea value={ticketMessage}
                                                              onChange={(e) => setTicketMessage(e.target.value)}
                                                              cols={50} rows={12} placeholder="پیام خود را بنویسید..."
                                                              className="bg-slate-100 mt-2 p-2 w-full max-h-[400px] outline-none border-r-2 border-amber-500"></textarea>
                                                    <div className="flex justify-end w-full mt-3">
                                                        <button onClick={sendTicket} disabled={loading}
                                                                className={`border-2 w-[30%]  ${loading && `cursor-not-allowed`} border-amber-500 text-center hover:bg-amber-500 hover:text-white duration-[0.4s] rounded-md text-amber-500 p-2`}>
                                                            {loading ? <Loading/> : "ثبت تیکت"}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>


                                            {/* --------------------------------- user tickets ------------------------------------ */}

                                            <div
                                                className={`w-full h-full mt-3 ${userTickets ? "block" : "hidden"} ${openMessagePage ? "hidden" : "block"}`}>
                                                <div
                                                    className="w-full flex justify-end pl-3 mb-3 rotate-180 text-[40px]">
                                                    <IoIosArrowRoundBack onClick={() => {
                                                        setUserTickets(false)
                                                        setTicketId("")
                                                    }} className="cursor-pointer"/></div>
                                                <div className="w-full px-2">
                                                    <h2 className="text-[24px] mr-5">تیکت های شما :</h2>

                                                    <div id="ticketsScroll"
                                                         className="h-full rounded-md bg-gray-100 max-h-[700px] w-full px-2 mt-5 py-5 flex flex-col gap-y-2 overflow-y-auto">
                                                        {loadingForTicket ?
                                                            <div className="flex justify-center gap-2">
                                                                <Loading/>
                                                                <span>لطفا منتظر بمانید</span>

                                                            </div>
                                                            :
                                                            allTickets.length > 0 ?
                                                                allTickets?.map((item, index) => (
                                                                    <div key={index}
                                                                         className="flex items-center justify-between bg-slate-100 p-5 rounded-lg cursor-pointer hover:tracking-wide hover:p-6 duration-[0.2s] hover:drop-shadow-md">
                                                                        <div className="flex flex-col">
                                                                            <p>{item.subject}</p>
                                                                            <p className="text-slate-500">{toJalaliDate(item?.createdAt)}</p>
                                                                        </div>

                                                                        <p>وضعیت :‌ <span
                                                                            className={`${item.status === "open" ? "text-green-600" : "text-red-600"}`}>{item?.status === "open" ? "باز" : "بسته"}</span>
                                                                        </p>

                                                                        <p onClick={() => {
                                                                            setTicketStatus(item?.status)
                                                                            setTicketId(item?._id)
                                                                        }} className="text-cyan-600 ">پیام ها</p>
                                                                    </div>
                                                                ))
                                                                :
                                                                <div className="flex justify-center items-center">
                                                                    در حال حاضر پیامی برای نمابش وجود ندارد!
                                                                </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>


                                            {/* ------------------ message page ---------------------------*/}

                                            {
                                                internetProblems ? (
                                                    <div className="w-full h-full flex items-center justify-center">
                                                        <Loadingcom/>
                                                    </div>
                                                ) : (
                                                    <div
                                                        className={openMessagePage ? "w-full h-full p-5 flex flex-col gap-y-4" : "hidden"}>
                                                        <div className="w-full flex justify-end text-[40px]">
                                                            <IoIosArrowRoundBack
                                                                onClick={() => setOpenMessagePage(false)}
                                                                className="cursor-pointer"/>
                                                        </div>
                                                        <div className="flex flex-col h-full">

                                                            <div
                                                                className="flex flex-col h-[70%] overflow-auto gap-y-4 p-5">
                                                                {
                                                                    noMessages ? (
                                                                        <div
                                                                            className="w-full h-full flex items-center justify-center">
                                                                            <p>برای این تیکت پیامی دریافت نشد !</p>
                                                                        </div>
                                                                    ) : (
                                                                        specificMessagePage.map((item, index) => (
                                                                            <div key={index}>
                                                                                <div
                                                                                    className={item.sender.driver ? "bg-slate-300 rounded-[20px] rounded-tr-none p-2" : "hidden"}>
                                                                                    {/* اسم و پیام */}
                                                                                    <div className="flex flex-col p-2">
                                                                                        <p className="text-[20px]">شما</p>
                                                                                        <p className="mt-5">
                                                                                            {item.sender.driver && item.description}
                                                                                        </p>
                                                                                    </div>

                                                                                    {/* تاریخ */}
                                                                                    <p className="text-slate-600 mr-2">{toJalaliDate(item.createdAt)}</p>

                                                                                </div>

                                                                                {/* ادمین  */}

                                                                                <div
                                                                                    className={!item.sender.driver ? `bg-blue-300 rounded-[20px] rounded-tl-none p-2` : `hidden`}>
                                                                                    {/* اسم و پیام */}
                                                                                    <div className="flex flex-col p-2">
                                                                                        <p className="text-[20px] ">پشتتیبانی</p>
                                                                                        <p className="mt-5">
                                                                                            {
                                                                                                !item.sender.driver && item.description
                                                                                            }
                                                                                        </p>
                                                                                    </div>

                                                                                    {/* تاریخ */}
                                                                                    <p className="text-slate-600 ml-2 text-left">{toJalaliDate(item.createdAt)}</p>

                                                                                </div>
                                                                            </div>
                                                                        ))

                                                                    )
                                                                }
                                                            </div>
                                                            {
                                                                ticketStatus === "open" ? (
                                                                    <div className="flex mb-32 items-center gap-x-5">
                                                                        <IoMdSend onClick={sendMessageToAdmin}
                                                                                  className="text-[25px] flex-grow cursor-pointer"/>
                                                                        <input
                                                                            onChange={(e) => setAnswerDescription(e.target.value)}
                                                                            value={answerDescription}
                                                                            className="py-5 border-none outline-none w-full"
                                                                            placeholder="پیام خود را بنویسید..."/>
                                                                    </div>
                                                                ) : (
                                                                    <div className="flex mb-32 items-center">
                                                                        <p className="text-[20px] text-red-500 text-center w-full">تیکت
                                                                            شما بسته شد !</p>
                                                                    </div>
                                                                )
                                                            }
                                                        </div>
                                                    </div>

                                                )
                                            }

                                        </>

                                    )}
                                </>
                            )}
                        </>
                    ) : (
                        <div className=" h-full w-full flex flex-col   items-center justify-center ">
                            <>
                                <div
                                    id="supportdiv"
                                    className=" flex  items-center justify-center  "
                                >
                                    <p className="text-[20px] text-center  text-[black] font-bold">
                                        در انتظار دریافت اطلاعات ...
                                    </p>
                                </div>
                            </>
                        </div>
                    )}
                </>
            ) : (
                navigate("/")
            )}
        </>
    );
};
export default Supportcom;
